import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Trans } from '@lingui/macro'
import DateRangePickerInput from '@/components/ui/inputs/DateRangePickerInput'
import { AIUsageOverviewComponent, AIUsageByDayComponent, AIUsageByUserComponent, ChartSkeleton } from '@/features/statistics'

type AIUsageSectionProps = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  selectedRange: [Date, Date]
  onRangeChange: (range: { start: Date | null; end: Date | null }) => void
  aiUsageData: any
  isLoadingAIUsage: boolean
  isMobile: boolean
}

export function AIUsageSection({ isExpanded, onChange, selectedRange, onRangeChange, aiUsageData, isLoadingAIUsage, isMobile }: AIUsageSectionProps) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: false } }}
      sx={{
        '& .MuiAccordionSummary-content': {
          margin: isMobile ? '10px 0' : undefined,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="aiUsage-content" id="aiUsage-header">
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          <Trans>AI Usage</Trans>
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Grid container spacing={isMobile ? 2 : 3}>
          <Grid item xs={12}>
            <DateRangePickerInput
              value={selectedRange}
              onChange={onRangeChange}
              sx={{
                width: '100%',
                '& .MuiInputBase-input': {
                  fontSize: isMobile ? '0.875rem' : undefined,
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <AIUsageOverviewComponent data={aiUsageData} isLoading={isLoadingAIUsage} />
          </Grid>

          <Grid item xs={12}>
            {isLoadingAIUsage ? <ChartSkeleton /> : <AIUsageByDayComponent data={aiUsageData} isLoading={isLoadingAIUsage} />}
          </Grid>

          <Grid item xs={12}>
            {isLoadingAIUsage ? <ChartSkeleton /> : <AIUsageByUserComponent data={aiUsageData} isLoading={isLoadingAIUsage} />}
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
